class WishlistButton extends HTMLElement {
    constructor() {
      super();
  
      this.button = this.querySelector("button");
      this.formId = this.dataset.formId;
      this.productId = this.dataset.productId;
      this.productTitle = this.dataset.productTitle;
      this.productUrl = this.dataset.productUrl;
      this.imageUrl = this.dataset.imageUrl;
  
      this.clickHandler = this.onClick.bind(this);
  
      if ('_swat' in window) {
        this.init(window._swat);
      } else {
        window.SwymCallbacks = window.SwymCallbacks || [];
        window.SwymCallbacks.push(this.init.bind(this));
      }
    }
  
    async init(swat) {
      this.button.classList.remove("loading");
      const wishlist = await new Promise((resolve) => {
        swat.fetch(resolve);
      });
      const isAdded = wishlist.some(({ empi }) => empi === Number(this.productId));
  
      if (isAdded) {
        this.button.classList.add("added");
      } else {
        this.button.removeAttribute('disabled');
        this.button.setAttribute("aria-disabled", "false");
        this.button.addEventListener("click", this.clickHandler);
      }
    }
  
  async onClick(event) {
    event.preventDefault();
    

    const form = document.querySelector(`[id='${this.formId}']`);

    // Check if variant is selected before proceeding
    if (!this.areRequiredVariantOptionsSelected()) {
      // Add submitted class to trigger validation UI
      document.querySelectorAll(`[id='${this.formId}'], [form='${this.formId}']`).forEach((element) => {
        element.classList.add('submitted');
      });
      form.classList.add('submitted');
      
      // Show error message
      const errorMessage = this.getVariantSelectionMessage();
      this.showErrorMessage(errorMessage);
      return;
    }

    const formData = new FormData(form);
    const variantId = Number(formData.get('id'));

    if (variantId) {
      const response = await new Promise((resolve) =>
        window._swat.addToWishList({ ...this.buildConfig(variantId) }, resolve)
      );

      this.button.classList.add("added");
      this.button.removeEventListener("click", this.clickHandler);
    }
  }

  areRequiredVariantOptionsSelected() {
    // Check if we're on a product page with variants
    if (!document.body.classList.contains('template-product')) {
      return true;
    }

    // Find variant selectors to check if options are selected
    const productInfoContainer = document.querySelector('.product__info-container');
    const variantRadios = productInfoContainer ? productInfoContainer.querySelector('variant-radios') : document.querySelector('variant-radios');
    const variantSelects = productInfoContainer ? productInfoContainer.querySelector('variant-selects') : document.querySelector('variant-selects');
    
    if (variantRadios) {
      // For radio button variant pickers - check visible fieldsets
      const fieldsets = variantRadios.querySelectorAll('fieldset:not(.hidden)');
      
      for (let fieldset of fieldsets) {
        // Check if this fieldset has any radio buttons with checked state
        const hasCheckedRadio = fieldset.querySelector('input:checked');
        if (!hasCheckedRadio) {
          return false;
        }
      }
    }
    
    if (variantSelects) {
      // For dropdown variant pickers
      const selects = variantSelects.querySelectorAll('select');
      
      for (let select of selects) {
        if (!select.value) {
          return false;
        }
      }
    }
    
    return true;
  }

  getVariantSelectionMessage() {
    // Find variant selectors to determine what options need to be selected
    const productInfoContainer = document.querySelector('.product__info-container');
    const variantRadios = productInfoContainer ? productInfoContainer.querySelector('variant-radios') : document.querySelector('variant-radios');
    const variantSelects = productInfoContainer ? productInfoContainer.querySelector('variant-selects') : document.querySelector('variant-selects');
    
    let unselectedOptions = [];
    
    if (variantRadios) {
      // For radio button variant pickers - check visible fieldsets
      const fieldsets = variantRadios.querySelectorAll('fieldset:not(.hidden)');
      
      fieldsets.forEach(fieldset => {
        const legend = fieldset.querySelector('legend span');
        const hasCheckedRadio = fieldset.querySelector('input:checked');
        
        if (!hasCheckedRadio && legend) {
          unselectedOptions.push(legend.textContent.trim());
        }
      });
    }
    
    if (variantSelects) {
      // For dropdown variant pickers
      const selects = variantSelects.querySelectorAll('select');
      
      selects.forEach(select => {
        const label = variantSelects.querySelector(`label[for="${select.id}"]`);
        
        if (!select.value && label) {
          unselectedOptions.push(label.textContent.trim());
        }
      });
    }
    
    if (unselectedOptions.length > 0) {
      return `Please select a ${unselectedOptions.join(', ')}`;
    }
    
    return 'Please select all product options';
  }

  showErrorMessage(message) {
    // Find or create error message wrapper
    const form = document.querySelector(`[id='${this.formId}']`);
    const productForm = form.closest('product-form');
    
    if (!productForm) return;
    
    let errorWrapper = productForm.querySelector('.product-form__error-message-wrapper');
    
    if (!errorWrapper) return;
    
    let errorMessage = errorWrapper.querySelector('.product-form__error-message');
    
    if (errorMessage) {
      errorMessage.textContent = message;
      errorWrapper.removeAttribute('hidden');
      
      // Auto-hide error message after 5 seconds
      setTimeout(() => {
        errorWrapper.setAttribute('hidden', '');
      }, 5000);
    }
  }
  
    buildConfig(variantId) {
      const data = this.getVariantData();
      const variant = data.find(({ id }) => id === variantId);
  
      return {
        epi: variantId,
        empi: this.productId,
        du: this.productUrl,
        dt: this.productTitle,
        iu: this.imageUrl,
        pr: variant.price / 100,
        vi: variant.title,
      };
    }
  
    getVariantData() {
      this.variantData =
        this.variantData ||
        JSON.parse(this.querySelector('[type="application/json"]').textContent);
      return this.variantData;
    }
}

customElements.define("wishlist-button", WishlistButton);

class CartWishlistButton extends HTMLElement {
  constructor() {
    super();

    this.button = this.querySelector('button');
    this.formId = this.dataset.formId;
    this.productId = Number(this.dataset.productId);
    this.productTitle = this.dataset.productTitle;
    this.productUrl = this.dataset.productUrl;
    this.imageUrl = this.dataset.imageUrl;
    this.variantId = Number(this.dataset.variantId);
    this.lineKey = this.dataset.lineKey;

    this.clickHandler = this.onClick.bind(this);

    if ('_swat' in window) {
      this.init(window._swat);
    } else {
      window.SwymCallbacks = window.SwymCallbacks || [];
      window.SwymCallbacks.push(this.init.bind(this));
    }
  }

  async init(swat) {
    this.button.classList.remove('loading');
    const wishlist = await new Promise((resolve) => {
      swat.fetch(resolve);
    });
    const isAdded = wishlist.some(({ empi }) => empi === Number(this.productId));

    if (isAdded) {
      this.button.classList.add('added');
    } else {
      this.button.removeAttribute('disabled');
      this.button.setAttribute('aria-disabled', 'false');
      this.button.addEventListener('click', this.clickHandler);
    }
  }

  async onClick(event) {
    event.preventDefault();
    setCartDrawerLoading(true);

    try {
      if (!this.variantId) return;
      if (!window.confirm('Move this item to your wishlist and remove it from your cart?')) {
        return;
      }

      if (!window._swat) return;

      await new Promise((resolve) =>
        window._swat.addToWishList({ ...this.buildConfig(this.variantId) }, resolve),
      );

      this.button.classList.add('added');
      this.button.removeEventListener('click', this.clickHandler);

      if (!this.lineKey) return;

      const body = JSON.stringify({
        id: this.lineKey,
        quantity: 0,
        sections: ['cart-drawer', 'cart-icon-bubble'],
        sections_url: window.location.pathname,
      });
      await fetch(`${routes.cart_change_url}`, {
        ...window.fetchConfig(),
        ...{ body },
      }).then((r) => r.json());

      if (typeof window.refreshCartFromServer === 'function') {
        await window.refreshCartFromServer();
      }

      const cartDrawer = document.querySelector('cart-drawer');
      if (cartDrawer && typeof cartDrawer.renderContents === 'function') {
        const data = await fetch('/?sections=cart-drawer,cart-icon-bubble', {
          method: 'GET',
        }).then((r) => r.json());
        cartDrawer.renderContents({ sections: data });
      }
    } catch (e) {
      console.error('Failed to remove cart line after moving to wishlist', e);
    } finally {
      setCartDrawerLoading(false);
    }
  }

  buildConfig(variantId) {
    const data = this.getVariantData();
    const variant = data.find(({ id }) => id === variantId);

    return {
      epi: variantId,
      empi: this.productId,
      du: this.productUrl,
      dt: this.productTitle,
      iu: this.imageUrl,
      pr: variant.price / 100,
      vi: variant.title,
    };
  }

  getVariantData() {
    this.variantData =
      this.variantData ||
      JSON.parse(this.querySelector('[type="application/json"]').textContent);
    return this.variantData;
  }
}

customElements.define('cart-wishlist-button', CartWishlistButton);

class DrawerWishlistButton extends HTMLElement {
  constructor() {
    super();
    this.button = this.querySelector('button');
    this._productData = null;
    this.clickHandler = this.onClick.bind(this);
  }

  setProduct({ productId, productTitle, productUrl, imageUrl, variant }) {
    this._productData = { productId, productTitle, productUrl, imageUrl, variant };
    this._reinit();
  }

  reset() {
    this.button.classList.add('loading');
    this.button.classList.remove('added');
    this.button.setAttribute('aria-disabled', 'true');
    this.button.removeEventListener('click', this.clickHandler);
    this._productData = null;
  }

  async _reinit() {
    if (!this._productData) return;

    this.button.classList.add('loading');
    this.button.classList.remove('added');
    this.button.removeEventListener('click', this.clickHandler);

    const doInit = async (swat) => {
      const wishlist = await new Promise((resolve) => swat.fetch(resolve));
      const isAdded = wishlist.some(({ empi }) => empi === Number(this._productData.productId));

      this.button.classList.remove('loading');
      if (isAdded) {
        this.button.classList.add('added');
      } else {
        this.button.setAttribute('aria-disabled', 'false');
        this.button.addEventListener('click', this.clickHandler);
      }
    };

    if ('_swat' in window) {
      doInit(window._swat);
    } else {
      window.SwymCallbacks = window.SwymCallbacks || [];
      window.SwymCallbacks.push(doInit);
    }
  }

  async onClick(event) {
    event.preventDefault();
    if (!this._productData || !window._swat) return;
    const { productId, productTitle, productUrl, imageUrl, variant } = this._productData;
    if (!variant) return;

    this.button.classList.add('adding');
    this.button.removeEventListener('click', this.clickHandler);

    const config = {
      epi: variant.id,
      empi: productId,
      du: productUrl,
      dt: productTitle,
      iu: imageUrl,
      pr: variant.price / 100,
      vi: variant.title,
    };

    try {
      await Promise.all([
        new Promise((resolve) => window._swat.addToWishList(config, resolve)),
        new Promise((resolve) => setTimeout(resolve, 700)),
      ]);
      this.button.classList.add('added');
    } finally {
      this.button.classList.remove('adding');
    }
  }
}

customElements.define('drawer-wishlist-button', DrawerWishlistButton);